import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useGoogleAuthCodeHandler = ({
  siteId,
  googleAdsTokenHandler,
  googleAdsAuthenticationStatusRefetch
}: {
  siteId: string;
  googleAdsTokenHandler: Function;
  googleAdsAuthenticationStatusRefetch: () => Promise<any>;
}) => {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const authCodeProcessedRef = useRef(false);
  const authCode = searchParams.get('code');

  useEffect(() => {
    if (authCode && !authCodeProcessedRef.current) {
      authCodeProcessedRef.current = true;

      const authenticateWithGoogle = async () => {
        try {
          setIsAuthenticating(true);

          await googleAdsTokenHandler({
            siteId,
            authenticationCode: authCode
          }).unwrap();

          await googleAdsAuthenticationStatusRefetch();

          searchParams.delete('code');
          searchParams.delete('scope');
          setSearchParams(searchParams);
        } catch (error) {
          console.error('Failed to authenticate with Google Ads:', error);
        } finally {
          setIsAuthenticating(false);
        }
      };

      void authenticateWithGoogle();
    }
  }, [
    authCode,
    siteId,
    googleAdsTokenHandler,
    googleAdsAuthenticationStatusRefetch,
    searchParams,
    setSearchParams
  ]);

  return { isAuthenticating };
};
